import 'isotope-layout';
// Implement isotope as Jquery Plugin :)
const jQueryBridget = require('jquery-bridget');
const Isotope = require('isotope-layout');
jQueryBridget('isotope', Isotope, $);

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    let TrendsGrid = false;
    let TrendsGridArguments = false;
    jQuery('[data-bs-toggle="tooltip"]').tooltip();
    if (jQuery('.trends-grid-container').length > 0) {
      TrendsGridArguments = {
        itemSelector: '.grid-item',
        percentPosition: true,
        masonry: {
          columnWidth: '.grid-sizer',
        },
      };
      TrendsGrid = jQuery('.trends-grid-container').isotope(TrendsGridArguments);
    }
    // Generic load by ajax for archives
    let lockLoadMore = false;
    jQuery('a[data-load-more]').on('click', function (e) {
      e.preventDefault();
      const caller = this;
      if (!lockLoadMore) {
        lockLoadMore = true;
        const pageLoaded = typeof jQuery(this).attr('data-page-to-load') === 'undefined' ? 2 : parseInt(jQuery(this).attr('data-page-to-load'));
        jQuery(caller).css('cursor', 'not-allowed');
        jQuery(caller).fadeOut();
        let currentQueryArgs = jQuery(this).attr('data-current-query-args');
        let hrefLink = this;

        if (currentQueryArgs) {
          currentQueryArgs = atob(currentQueryArgs);
        }
        const loadMoreType = jQuery(this).data('load-more');
        const lastIndex = parseInt(jQuery(this).attr('data-last-index'));
        const postsElement = jQuery(this).data('posts-element');
        const taxonomyFilters = jQuery(this).data('taxonomy-filters');
        let numberPosts = jQuery(this).data('number-posts');
        if (!numberPosts) {
          numberPosts = 9;
        }
        numberPosts *= (pageLoaded-1);
        const templateToLoad = loadMoreType + '_post';
        jQuery.ajax({
          url: '/wp/wp-admin/admin-ajax.php',
          method: 'POST',
          data: {
            action: 'generic_posts',
            postType: loadMoreType,
            template: templateToLoad,
            lastIndex: lastIndex,
            taxonomyFilters: taxonomyFilters,
            numberPosts: numberPosts,
            currentQueryArgs: currentQueryArgs
          },
          dataType: 'json',
        }).done(function (response) {
          lockLoadMore = false;
          jQuery(caller).css('cursor', 'pointer');
          jQuery(postsElement).append(response.html);
          jQuery(caller).attr('data-last-index', lastIndex + numberPosts);
          if (TrendsGrid) {
            //TrendsGrid.isotope('destroy');
            TrendsGrid.isotope(TrendsGridArguments);
            TrendsGrid.isotope('reloadItems');
          }
          if (response.hasMorePosts) {
            if (hrefLink.href.includes('?load-page=')) {
              hrefLink.setAttribute('href', '?load-page='+(pageLoaded+1));
              const url = new URL(window.location.origin + window.location.pathname);
              const params = new URLSearchParams(window.location.search);
              params.set('load-page', (pageLoaded));
              url.search = `?${params.toString()}`;
              window.history.pushState({}, '', url);
              jQuery(caller).attr('data-page-to-load', (pageLoaded+1));
            }
            jQuery(caller).fadeIn();
          } else {
            jQuery(caller).addClass('d-none');
          }
        });
      }
    });

    const params = new URLSearchParams(window.location.search);
    if (params.get('load-page') && params.get('load-page') > 1) {
      let $linkLoadMore = jQuery('a[data-load-more][href!="#"]');
      if ($linkLoadMore.length > 0) {
        $linkLoadMore.attr('data-page-to-load', params.get('load-page'));
        $linkLoadMore.trigger('click');
      }
    }
  },
};
